export default {
    methods: {
        roundValue(value, decimals) {
            if (!value) {
                value = 0;
            }

            if (!decimals) {
                decimals = 0;
            }

            value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
            return value;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/roundValue.js